import { setHours, setMinutes, setSeconds } from 'date-fns';

export const handleValidToDate = (validTo: Date | null) => {
  if (!validTo) return null;

  return setHours(setMinutes(setSeconds(validTo, 59), 59), 23);
};
